import { render } from "./DisplayRemainingPlaces.vue?vue&type=template&id=a56fe958&ts=true"
import script from "./DisplayRemainingPlaces.vue?vue&type=script&lang=ts"
export * from "./DisplayRemainingPlaces.vue?vue&type=script&lang=ts"

import "./DisplayRemainingPlaces.vue?vue&type=style&index=0&id=a56fe958&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__